<div class="leftPanel">
    <div class="content">
        <div class="search mt-10 mb-20">
            <button
                [disabled]="!evaluationAthleteRights.ADD"
                mat-raised-button color="accent"
                (click)="onNewClicked()">
                {{ 'NewEvaluation' | translate }}
            </button>

            <!--
            <button mat-raised-button color="accent" *is_granted="ROLE_COACH()" (click)="onNewClicked()">{{ 'NewEvaluation' | translate }}</button>
            <mat-form-field>
                <input matInput [matDatepicker]="picker" placeholder="{{ 'PlaceholderChooseADate' | translate }}" [(ngModel)]="searchTerms">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            -->
        </div>
        <div *ngIf="evaluationsAthletes && 0 < evaluationsAthletes.length; else noEvaluation" class="evaluation-athlete-list-wrapper">
            <mat-accordion [multi]="true">
                <mat-expansion-panel *ngFor="let type of getEvaluationAthletesType(evaluationsAthletesGrouped)" [expanded]="currentEvaluationType === type">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{ type | translate }}
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <mat-list *ngIf="getEvaluationAthletesByType(type) as result;">
                        <ng-container *ngIf="result.length > 0; else noItems">
<!--                               mat-list-item on div -->
                            <div class="evaluation-list-item"
                               *ngFor="let evalAthlete of result; let i = index; last as last;"
                            >
                            <div class="active" *ngIf="this.evaluationAthlete && evalAthlete.id === this.evaluationAthlete.id"></div>
                            <a [routerLink]="'/' + organization.code + '/athletes/' + athleteUser.id + '/evaluations/' + evalAthlete.id">
                                <h3 mat-line>{{ evalAthlete.date|appDate:'mediumDate' }}</h3>
                                <div class="mr-10">
                                    <mat-chip-set>
                                        <mat-chip [ngClass]="evalAthlete.status === 'opened' ? 'mat-chip-accent' : ''">{{ evalAthlete.status ?? ''|translate }}</mat-chip>
                                    </mat-chip-set>
                                </div>
                            </a>
                                <button
                                        mat-icon-button
                                        [matMenuTriggerFor]="rowMoreMenu">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <!-- TODO: check rights -->
                                <mat-menu #rowMoreMenu="matMenu" xPosition="before">
                                    <button mat-menu-item
                                            [disabled]="false"
                                            (click)="onDeleteEvaluationClicked(evalAthlete)">
                                        <mat-icon>delete_outlined</mat-icon>&nbsp;{{ 'Delete' | translate }}
                                    </button>
                                </mat-menu>

                                <input *ngIf="currentEvaluationType === type && selectedEvaluations$"
                                    type="checkbox"
                                    #evaluationCheckbox
                                    [checked]="evalAthlete.id === this.evaluationAthlete.id"
                                    [disabled]="evalAthlete.id === this.evaluationAthlete.id"
                                    (change)="onSelectEvaluation($event, evalAthlete, evalAthlete.id!)">
                                <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
                            </div>
                        </ng-container>

                        <ng-template #noItems>
                            <mat-list-item>
                                <h3 mat-line>{{ 'NoEvaluationFound'|translate }}</h3>
                            </mat-list-item>
                        </ng-template>
                    </mat-list>

                </mat-expansion-panel>
            </mat-accordion>
        </div>
        <ng-template #noEvaluation>
            <div class="evaluation-athlete-no-evaluation">
                {{ 'EvaluationAthleteNoEvaluationSideMenu'|translate }}
            </div>
        </ng-template>
    </div>
</div>
